module.exports = __webpack_public_path__ + "assets/zhuanzheng2.275e82e3.svg";